<div class="more-filters-dialog">
  <div class="dialog-header">
    <h2>{{ 'pages.userRecords.advancedFilters' | translate }}</h2>
    <button class="close-btn" (click)="cancel()">
      <i class="icon-close"></i>
    </button>
  </div>

  <div class="dialog-content">
    <form [formGroup]="filtersForm">
      <div class="filter-row">
        <div class="filter-field">
          <app-form-select #cardStatusSelect
            [options]="data.cardStatusOptions" 
            formControlName="cardStatus"
            label="{{ 'common.fields.cardStatus' | translate }}"
            [placeholder]="'common.fields.cardStatus' | translate">
          </app-form-select>
        </div>
        <div class="filter-field">
          <app-form-select #roleSelect
            [options]="data.roleOptions" 
            formControlName="role"
            label="{{ 'common.fields.role' | translate }}"
            [placeholder]="'common.fields.role' | translate">
          </app-form-select>
        </div>
      </div>

      <div class="filter-row">
        <div class="filter-field single">
          <app-form-select #confirmedSelect
            [options]="data.confirmedOptions" 
            formControlName="confirmed"
            label="{{ 'pages.userRecords.accountConfirmed' | translate }}"
            [placeholder]="'pages.userRecords.accountConfirmed' | translate">
          </app-form-select>
        </div>
      </div>

      <div class="address-section">
        <h4>{{ 'common.fields.address-short' | translate }}</h4>
        <div class="address-row">
          <div class="address-field number">
            <app-form-input 
              formControlName="number"
              [placeholder]="123"
              label="{{ 'common.fields.address.number' | translate }}">
            </app-form-input>
          </div>
          <div class="address-field street">
            <app-form-input 
              formControlName="streetName"
              [placeholder]="'common.fields.address.streetName' | translate"
              label="{{ 'common.fields.address.streetName' | translate }}">
            </app-form-input>
          </div>
          <div class="address-field postcode">
            <app-form-input 
              formControlName="postCode"
              [placeholder]="'A1A 1A1'"
              label="{{ 'common.fields.address.postCode' | translate }}">
            </app-form-input>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="dialog-actions">
    <button class="bciti-button bciti-button--blue" (click)="applyFilters()">
      {{ 'pages.userRecords.applyFilters' | translate }}
    </button>
  </div>
</div>
